




















import {Vue, Component, PropSync} from 'vue-property-decorator';

@Component
export default class AdditionalInputItems extends Vue {
  @PropSync('extraInfo') extraInfoSync: string;
}
